import { useTimelineDates, useDispatch } from 'hooks';

export default action => {
  const { startDate, endDate } = useTimelineDates();
  const dispatch = useDispatch(action);
  return payload => dispatch({ payload, startDate, endDate });
};
